module.exports = __webpack_public_path__ + "img/feature-item-fee.e6848a2d.svg";